import * as React from "react"
import { formatPercentage } from "@ui-seeker/utils"

import { NotAllowedBlock } from "@components"
import { adminScrapingDataReviewPercentageData } from "../../../@signals"


export default function CommonColumn(name, label, percentageKey, visible=false) {
    return {
        name: name,
        label: `${label} (${formatPercentage(adminScrapingDataReviewPercentageData.value[percentageKey] || 0, { decimals: 2 })})`,
        options: {
            display: visible,
            filter: false,
            setCellHeaderProps: () => ({
                sx: {
                    textAlign: "center",
                    minWidth: 80,
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
            setCellProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
            customBodyRowRender: value => value ? value : <NotAllowedBlock />
        }
    }
}